import { GroupedCustomTabs } from '@/components/pages/offers-dashboard/types';
import { FilterArray } from '@/types';
import { IDropdownOption } from 'shared-components';
import { IApplyDashboardRowTotals } from 'types';
import { action } from 'typesafe-actions';
import { IDropdownOptionMulti } from './sagas/handleGetAllFilters';
import { offersDashboardActionTypes } from './types';
import { TableRow } from '@/components/organisms/ApplyDataGrid/table/types';

/**x
 * Totals actions
 */
export const clearTotals = () => action(offersDashboardActionTypes.CLEAR_TOTALS);
export const requestTotals = () => action(offersDashboardActionTypes.GET_TOTALS);
export const getTotalsSuccess = (totals: IApplyDashboardRowTotals) =>
  action(offersDashboardActionTypes.GET_TOTALS_SUCCESS, { totals });

export const getTotalsFailure = (e: Error) => action(offersDashboardActionTypes.GET_TOTALS_FAILURE, e);

/**
 * dashboard actions
 */
export const clearDashboardRows = () => action(offersDashboardActionTypes.CLEAR_DASHBOARD_ROWS);
export const requestDashboardRows = () => action(offersDashboardActionTypes.GET_DASHBOARD_ROWS);
export const getDashboardRowsSuccess = (rows: Array<TableRow>) =>
  action(offersDashboardActionTypes.GET_DASHBOARD_ROWS_SUCCESS, { rows });

export const getDashboardRowsFailure = (e: Error) => action(offersDashboardActionTypes.GET_DASHBOARD_ROWS_FAILURE, e);

/**
 * Filter actions
 */

export const requestFilters = () => action(offersDashboardActionTypes.GET_FILTERS);
export const getFiltersSuccess = (
  filterOptions: Partial<Record<string, IDropdownOption[] | IDropdownOptionMulti[] | string[]>>,
) => action(offersDashboardActionTypes.GET_FILTERS_SUCCESS, filterOptions);

export const getFiltersFailure = (e: Error) => action(offersDashboardActionTypes.GET_FILTERS_FAILURE, e);
export const setFilters = (filters: FilterArray) => action(offersDashboardActionTypes.SET_FILTERS, { filters });
export const setIsFiltersVisible = (isFiltersVisible: boolean) =>
  action(offersDashboardActionTypes.SET_FILTERS_VISIBLE, { isFiltersVisible });

/**
 * Table control header actions
 */

export const setSort = (sort: string) => action(offersDashboardActionTypes.SET_SORT, sort);
export const selectAll = (checked: boolean) => {
  return action(offersDashboardActionTypes.SELECT_ALL, checked);
};
export const setSelectedRows = (selectedRows: string[]) =>
  action(offersDashboardActionTypes.SET_SELECTED_ROWS, { selectedRows });
export const setIsDropdownDisabled = (isDisabled: boolean) =>
  action(offersDashboardActionTypes.SET_IS_DROPDOWN_DISABLED, { isDisabled });

/**
 * Sidebar tab actions
 */

export const switchTab = (tabs: string) => action(offersDashboardActionTypes.SWITCH_TAB, { tabs });
export const setCustomTabs = (tabs: GroupedCustomTabs) => action(offersDashboardActionTypes.SET_CUSTOM_TABS, { tabs });
